export const LOOKUP_CONFIG_LOCALE_ZHCHS = {
    placeholder: 'éæ©è¡¨ååæ°æ®',
    code: 'ç¼å·',
    name: 'åç§°',
    select: 'éæ©å¸®å©åæ°æ®',
    filter: 'éç½®æ¡ä»¶',
    helpidEmpty: 'helpIdä¸è½ä¸ºç©º',
    selectTitle: 'å¸®å©åæ°æ®éæ©',
    lookupTitle: 'å¸®å©éç½®',
    sure: 'ç¡®å®',
    cancel: 'åæ¶',
    successSave: 'ä¿å­æå',
    helpIdError: 'è¯·éæ©å¸®å©åæ°æ®',
    fileNamePlaceholder: 'éæ©å¸®å©ææ¬å­æ®µ',
    selectFileNameTitle: 'ææ¬å­æ®µéæ©å¨',
    bindingPath: 'ç»å®å­æ®µ',
    fieldError: 'å·²ç»å®å­æ®µä¸å­å¨ï¼',
    textFieldLable: 'å¸®å©ææ¬å­æ®µ',
    loadTypeTitle: 'éæ©å è½½æ¹å¼',
    loadTypeList: {
        all:'å¨é¨å è½½',
        layer:'åå±å è½½',
        default: 'é»è®¤'
    },
    powerTitle:'æéè®¾ç½®',
    powerObjLabel:'æéå¯¹è±¡',
    powerFieldLabel:'æéå­æ®µ',
    powerOperateLabel:'æéæä½',
    linkfieldLabel:'å¸®å©å³èå­æ®µ',
    powerDataTitle:'æéå¯¹è±¡éæ©',
    powerFieldTitle:'æéå­æ®µéæ©',
    powerOperateTitle:'æä½éæ©',
    businessLable:'ä¸å¡å¯¹è±¡',
    powerLable:'æéå¯¹è±¡',
    powerError:'è¯·éæ©æéå¯¹è±¡',
    operateError:'è¯·éæ©æä½',
    linkfieldError:'è¯·éæ©æéå­æ®µ'
};
